import { useReducer } from 'react';
import getActions from './getActions';
import reducer, { initialState, IReducerState } from './reducer';

export default (): { state: IReducerState } & ReturnType<typeof getActions> => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    ...getActions({}, dispatch),
  };
};
